/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description CancelBatchReason
 */
import _ from 'lodash';
import { Button as AntButton, ButtonProps, App } from 'antd';

/**
 * CancelBatchReason
 */
const CancelBatchReason: React.FC<{ batchMeta: EligibilityBatchUpload.IBatchEligibilityResponseList } & ButtonProps> = ({
	batchMeta,
	...restProps
}) => {
	const { modal } = App.useApp();
	const handleClick = () => {
		const cancellationReason = _.find(batchMeta?.cancellationDetails, (details) => !_.isEmpty(details?.createdBy))?.reason;
		const cancellationDetails = _.find(batchMeta?.cancellationDetails, (details) => _.isEmpty(details?.createdBy))?.reason;
		modal.info({
			width: 560,
			closable: true,
			title: 'Batch Cancellation Summary',
			content: (
				<>
					<div>
						<span className='font-semibold'>{'Batch Number: '}</span>
						{batchMeta.sequenceId}
					</div>
					{cancellationReason && (
						<div>
							<span className='font-semibold'>{'Cancellation Reason by User: '}</span>
							{cancellationReason}
						</div>
					)}
					{cancellationDetails && (
						<div>
							<span className='font-semibold'>{'Cancellation Reason by System: '}</span>
							{cancellationDetails}
						</div>
					)}
				</>
			),
			icon: null,
		});
	};
	return (
		<AntButton key='view-eligibility-batch-cancel-reason' onClick={handleClick} data-testid='cancellation-summary-btn' {...restProps}>
			{'Cancellation Summary'}
		</AntButton>
	);
};

export default CancelBatchReason;
